import { useState, useEffect } from 'react'
import { MessageCircle } from 'lucide-react'
import { Link } from 'react-router-dom'
import { cn } from '../../lib/utils'

function ContactButton() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 200)
    }

    window.addEventListener('scroll', toggleVisibility)
    return () => window.removeEventListener('scroll', toggleVisibility)
  }, [])

  return (
    <Link
      to="/contact"
      aria-label="Me Contacter"
      className={cn(
        'fixed bottom-8 left-8 z-40',
        'bg-secondary hover:bg-secondary-600 text-white',
        'w-14 h-14 rounded-full shadow-lg',
        'flex items-center justify-center',
        'transition-all duration-300',
        'focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2',
        'hover:shadow-xl hover:scale-110',
        'group',
        isVisible
          ? 'opacity-100 translate-y-0'
          : 'opacity-0 translate-y-10 pointer-events-none'
      )}
    >
      <MessageCircle className="h-6 w-6 transition-transform group-hover:scale-110" />

      {/* Tooltip */}
      <span className={cn(
        'absolute left-full ml-3 px-3 py-1.5',
        'bg-gray-900 text-white text-sm font-medium rounded-lg',
        'whitespace-nowrap opacity-0 invisible',
        'group-hover:opacity-100 group-hover:visible',
        'transition-all duration-200',
        'pointer-events-none'
      )}>
        Me Contacter
      </span>
    </Link>
  )
}

export default ContactButton
